import type { IForgotPasswordAlertViewModel } from "@/components/screens/login/types/login";
import Icon from "@/components/library/Icon";

const ForgotPasswordAlert = ({ vm }: { vm: IForgotPasswordAlertViewModel }) => (
  <div
    className={`flex ${vm.classNames.containerClassNames} items-center xs:space-x-4`}
    id="forgot-password-alert"
    data-testid="forgot-password-alert"
    data-active={vm.dataActive}
  >
    <div className="xs:flex hidden">
      <Icon icon={vm.icon} size="4x" />
    </div>
    <span className="font-bold text-2xl text-white">
      {vm.labels.alertTitle}
    </span>
  </div>
);

export default ForgotPasswordAlert;
